var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYoutubeIcon = function SvgYoutubeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 16,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.272 12.073a2.048 2.048 0 0 0-1.435-1.447c-1.27-.34-6.339-.34-6.339-.34s-5.08 0-6.339.34a2.048 2.048 0 0 0-1.435 1.447c-.34 1.27-.34 3.928-.34 3.928s0 2.658.34 3.928c.188.706.741 1.258 1.435 1.446 1.27.341 6.339.341 6.339.341s5.08 0 6.339-.34a2.048 2.048 0 0 0 1.435-1.447c.34-1.27.34-3.928.34-3.928s0-2.658-.34-3.928Zm-9.432 6.339V13.59L19.085 16l-4.245 2.412Z",
    fill: "#424242"
  })));
};

export default SvgYoutubeIcon;